/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import { queryOptions, useQuery } from "@tanstack/react-query"

import fetch from "~/backend/axiosClient"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"

import type { GetCertificateRequestsForSupplierStatsQueryResponse } from "../types/GetCertificateRequestsForSupplierStats.ts"

export const getCertificateRequestsForSupplierStatsQueryKey = () =>
  [
    {
      url: "/v1/certificate-request/get-certificate-requests-for-supplier-stats",
    },
  ] as const

export type GetCertificateRequestsForSupplierStatsQueryKey = ReturnType<
  typeof getCertificateRequestsForSupplierStatsQueryKey
>

/**
 * @summary Get certificate requests for supplier stats
 * {@link /v1/certificate-request/get-certificate-requests-for-supplier-stats}
 */
export async function getCertificateRequestsForSupplierStats(
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    GetCertificateRequestsForSupplierStatsQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/v1/certificate-request/get-certificate-requests-for-supplier-stats`,
    ...requestConfig,
  })
  return res
}

export function getCertificateRequestsForSupplierStatsQueryOptions(
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = getCertificateRequestsForSupplierStatsQueryKey()
  return queryOptions<
    ResponseConfig<GetCertificateRequestsForSupplierStatsQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<GetCertificateRequestsForSupplierStatsQueryResponse>,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getCertificateRequestsForSupplierStats({
        ...config,
        signal: config.signal ?? signal,
      })
    },
  })
}

/**
 * @summary Get certificate requests for supplier stats
 * {@link /v1/certificate-request/get-certificate-requests-for-supplier-stats}
 */
export function useGetCertificateRequestsForSupplierStats<
  TData = ResponseConfig<GetCertificateRequestsForSupplierStatsQueryResponse>,
  TQueryData =
    ResponseConfig<GetCertificateRequestsForSupplierStatsQueryResponse>,
  TQueryKey extends QueryKey = GetCertificateRequestsForSupplierStatsQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<GetCertificateRequestsForSupplierStatsQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey =
    resolvedOptions?.queryKey ??
    getCertificateRequestsForSupplierStatsQueryKey()

  const query = useQuery(
    {
      ...getCertificateRequestsForSupplierStatsQueryOptions(config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
